import React, { FC } from 'react';
import styled, { css } from 'styled-components/macro';

export const IconStyles = css`
    font-family: 'YousicianIcons' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    letter-spacing: 0;
    -webkit-font-feature-settings: 'liga';
    -moz-font-feature-settings: 'liga=1';
    -moz-font-feature-settings: 'liga';
    -ms-font-feature-settings: 'liga' 1;
    font-feature-settings: 'liga';
    -webkit-font-variant-ligatures: discretionary-ligatures;
    font-variant-ligatures: discretionary-ligatures;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
`;

const Icon = styled.span<{ $size: number }>`
    ${IconStyles}

    ${(props) =>
        props.$size &&
        css`
            font-size: ${props.$size}px;
            width: ${props.$size}px;
        `}
`;

export type IconProps = {
    size: number;
    name: string;
} & React.HTMLAttributes<HTMLSpanElement>;

const IconComponent: FC<IconProps> = ({ name, size, ...rest }) => {
    return (
        <Icon $size={size} {...rest}>
            {name}
        </Icon>
    );
};

export default IconComponent;
